import React, { useState, useEffect, useRef, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import PdfViewer from "../chat/PdfViewer";
import Cookies from "js-cookie";
import api from "../chat/api";
import { getFreshAccessToken } from "../chat/api";
import {
  fetchExcelChat,
  resetExcelChatState,
  fetchExcelSummary,
  updatePartialAnswer,
  updateSummaryMetadata,
  resetStopStreaming,
  stopStreaming
} from "../../Features/excelChatSlice";
import { Header } from "../../components/Header/Header";
import axios from "axios";
import { format } from "date-fns";
import SpreadsheetViewer from "./SpreadsheetViewer";
import CustomBarChart from "./CustomBarChart";
function ExcelChat() {
  const location = useLocation();
  const { excelKey, excelUrl, excelId } = location.state || {};

  const dispatch = useDispatch();
  const chatContainerRef = useRef(null);
  const [inputMessage, setInputMessage] = useState("");
  const [isPopupVisible, setPopupVisible] = useState(false);
  const status = useSelector((state) => state.chat.status);
  const [clickedIndex, setClickedIndex] = useState(null);
  const [textAreaHeight, setTextAreaHeight] = useState("auto");
  const textareaRef = useRef(null);
  const [isSending, setIsSending] = useState(false);
  const [chatHistory, setChatHistory] = useState([]);
  const [isSummaryLoading, setIsSummaryLoading] = useState(false);

const [isSummaryWebSocketActiveNow, setIsSummaryWebSocketActiveNow] = useState(false);
const [shouldForceStopThinking, setShouldForceStopThinking] = useState(false);
const [streamingBotMessageId, setStreamingBotMessageId] = useState(null);
  const [hasAskedQuestion, setHasAskedQuestion] = useState(false);
  const partialAnswer = useSelector(
    (state) => state.excelChat?.partialAnswer || ""
  );
  const barChart = useSelector((state) => state.excelChat.barChart) || [];

  const finalAnswer = useSelector(
    (state) => state.excelChat?.finalAnswer || ""
  );

  const partialSummary = useSelector(
    (state) => state.excelChat?.partialSummary || ""
  );
  const finalSummary = useSelector(
    (state) => state.excelChat?.finalSummary || ""
  );
  const summaryStatus = useSelector((state) => state.excelChat.summaryStatus);

  useEffect(() => {
    if (excelKey) {
      dispatch(fetchExcelSummary({ excelKey }));
    }
  }, [excelKey, dispatch]);

  // ExcelChat.js
useEffect(() => {
  if (summaryStatus === "succeeded") {
    setIsSummaryCompleted(true);
  }
}, [summaryStatus]);
  const [lineCount, setLineCount] = useState(1);

  const getLineStyle = () => {
    if (lineCount === 1) {
      return "rounded-[40px] border border-[rgba(0,0,0,0.10)]";
    } else if (lineCount === 2) {
      return "rounded-[20px] border border-[rgba(187,66,174,0.36)]";
    } else {
      return "rounded-[16px] border border-[rgba(187,66,174,0.36)]";
    }
  };
  
  // 1️⃣  ⬇️  put this near the top of ExcelChat(), right after the hooks
useEffect(() => {

});

  const userInitials = useSelector(
    (state) => state.excelChat.userInitials || "🧑🏻‍💻"
  );


  const [isUserScrolling, setIsUserScrolling] = useState(false);

  const [showEarlierMessagesPopup, setShowEarlierMessagesPopup] =
    useState(false);

  useEffect(() => {
    if (partialSummary) {
      setChatHistory((prev) => {
        const lastMessage = prev[0];
        if (
          lastMessage?.sender === "bot" &&
          lastMessage.text.startsWith("Summary")
        ) {
          lastMessage.text = partialSummary;
          return [...prev];
        } else if (
          !prev.some(
            (msg) => msg.sender === "bot" && msg.text === partialSummary
          )
        ) {
          return [{ id: Date.now(), sender: "bot", text: partialSummary }];
        }
        return prev;
      });
    }
  }, [partialSummary]);

  useEffect(() => {
    // run the effect as soon as the final WebSocket frame arrives,
    // even if the summary text is an empty string ("")
    if (finalSummary !== undefined) {
      setChatHistory((prev) => {
        const lastMessage = prev[0];
  
        // only overwrite the “Summarizing…” text when the backend
        // actually sent non-empty summary content
        if (finalSummary.trim()) {
          if (lastMessage?.sender === "bot") {
            lastMessage.text = finalSummary;
            return [...prev];
          }
          return [
            { id: Date.now(), sender: "bot", text: finalSummary },
            ...prev,
          ];
        }
  
        // summary came back empty → keep existing placeholder
        return prev;
      });
  
      setIsSummaryCompleted(true);
    }
  }, [finalSummary]);
  



  const formattedTimestamp = useSelector(
    (state) => state.excelChat.formattedTimestamp
  );

  const error = useSelector((state) => state.excelChat?.error);
  const generatedQuestions = useSelector(
    (state) => state.excelChat.generatedQuestions
  );

  const { botMessageId, runId } = useSelector((state) => state.excelChat);

  useEffect(() => {}, [generatedQuestions]);

  useEffect(() => {
    return () => {
      dispatch(resetExcelChatState());
    };
  }, [dispatch]);

  const [isCopyPopupVisible, setCopyPopupVisible] = useState(false);
  const [thumbsUpClicked, setThumbsUpClicked] = useState({});
  const [thumbsDownClicked, setThumbsDownClicked] = useState({});
  const [copiedMessageId, setCopiedMessageId] = useState(null);
  const [typedDummyMessages, setTypedDummyMessages] = useState([]);

const formatText = useCallback((input) => {
  let formattedText = input
    .trimStart()
    .replace(/^### Table.*\n?/gm, "") // remove markdown table title
.replace(/^### (.*$)/gm, '<div style="font-size: 16px; font-weight: 600; margin: 12px 0 6px; color: #000;">$1</div>')

    .replace(/\n{2,}(?=\|.+\|[\r\n]+\|[-\s|:]+\|)/g, "") 

  // Step 2: Parse markdown tables
  const tableRegex = /\|(.+?)\|[\r\n]+\|([-\s|:]+)\|[\r\n]+((\|.*?\|[\r\n]+)+)/g;
  formattedText = formattedText.replace(tableRegex, (match, header, separator, body) => {
    const headers = header.split("|").map(h =>
      `<th style="padding: 8px; text-align: left; border: 1px solid rgb(201, 94, 190); background-color: rgb(250, 235, 247); font-size: 15px; font-weight: 600; color: rgb(201, 94, 190);">${h.trim()}</th>`
    ).join("");

    const rows = body.trim().split("\n").map(row => {
      const cells = row.split("|").slice(1, -1).map(cell =>
        `<td style="padding: 8px; border: 1px solid rgba(201, 94, 190, 0.3); font-size: 14px; font-weight: 400; color: #444;">${cell.trim().replace(/\*\*(.*?)\*\*/g, "<b>$1</b>")}</td>`
      ).join("");
      return `<tr>${cells}</tr>`;
    }).join("");

    return `
      <div style="overflow-x: auto; margin-top: 2px; margin-bottom: 8px;">
<table style="border-collapse: collapse; width: 100%; font-size: 14px; border: 1px solid rgb(201, 94, 190);">
          <thead><tr style="background-color: #f5f5f5;">${headers}</tr></thead>
          <tbody>${rows}</tbody>
        </table>
      </div>
    `;
  });

  // Step 3: Apply formatting rules
  formattedText = formattedText.replace(/(^|\n)\s*\*\s+/g, "$1• "); // bullets
  formattedText = formattedText.replace(/\*\*(.*?)\*\*/g, "<b>$1</b>"); // bold
  formattedText = formattedText.replace(/^([^:\n]+):\s*(.+)$/gm, "<b>$1:</b> $2"); // label:value
  formattedText = formattedText.replace(/(?<!<\/table>)\n(?!<table)/g, "<br/>"); // convert line breaks (ignore tables)

  // Step 4: Wrap final result
  return `<div style="white-space: pre-wrap; word-wrap: break-word; line-height: 1.5;">${formattedText}</div>`;
}, []);
  const [showThumbsDownPopup, setShowThumbsDownPopup] = useState(false);
  const [clientMessage, setClientMessage] = useState("");
  const [showFeedbackModal, setShowFeedbackModal] = useState(false);
  const [selectedFeedbackType, setSelectedFeedbackType] = useState(null);
  const [feedbackMessage, setFeedbackMessage] = useState("");
  const [messageIdToFeedback, setMessageIdToFeedback] = useState(null);
  const [runIdToFeedback, setRunIdToFeedback] = useState(null);
  const [showDummyMessages, setShowDummyMessages] = useState(true);
  const [isAwaitingResponse, setIsAwaitingResponse] = useState(false);
  const [isThinking, setIsThinking] = useState(false);
  const [isSummaryCompleted, setIsSummaryCompleted] = useState(false);

  const navigate = useNavigate();

  const handleSend = (messageToSend) => {
    if (isAwaitingResponse || isSummaryLoading) return;
    const message = messageToSend || clientMessage;
    if (message.trim() && excelKey) {
      setHasAskedQuestion(true);
      setShouldForceStopThinking(false);
      const userMessage = { id: Date.now(), sender: "user", text: message };
      setChatHistory((prev) => [
        ...prev,
        { ...userMessage, timestamp: new Date().toISOString() },
      ]);

      setChatHistory((prev) => [
        ...prev,
        {
          id: Date.now(),
          sender: "bot",
          text: "",
          final: false,
          timestamp: new Date().toISOString(),
        },
      ]);
      setStreamingBotMessageId(botMessageId);
      setIsThinking(true);
      setIsAwaitingResponse(true);
      dispatch(fetchExcelChat({ excelKey, clientMessage: message,id:excelId }));
      setClientMessage("");
      setTextAreaHeight("auto");
      setShowDummyMessages(false);
      setClickedIndex(null);
      if (textareaRef.current) {
        textareaRef.current.style.height = "auto";
      }
    }
  };

  
    useEffect(() => {
      if (textareaRef.current) {
        const height = textareaRef.current.scrollHeight;
        if (height <= 30) setLineCount(1);
        else if (height <= 60) setLineCount(2);
        else setLineCount(3);
      }
    }, [clientMessage]);

  useEffect(() => {
    if (status === "loading" && !partialAnswer) {
      setIsThinking(true);
    } else if (partialAnswer) {
      setIsThinking(false);
    }
  }, [status, partialAnswer]);

  useEffect(() => {
    if (status === "succeeded" || status === "failed") {
      setIsThinking(false);
    }
  }, [status]);

  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = textAreaHeight;
    }
    return () => {
      if (textareaRef.current) {
        textareaRef.current.style.height = textAreaHeight;
      }
    };
  }, [textAreaHeight]);

  useEffect(() => {
    const fetchSummary = async () => {
      if (excelKey) {
        setIsSummaryLoading(true);
        try {
          setIsSummaryCompleted(false);
          setChatHistory((prev) => {
            if (
              !prev.some(
                (msg) => msg.sender === "bot" && msg.text === "Summarizing..."
              )
            ) {
              return [
                { id: Date.now(), sender: "bot", text: "Summarizing..." },
                ...prev,
              ];
            }
            return prev;
          });

          
          const response = await api.get(
            `api/v1/excel/summary-and-questions/?excel_key=${excelKey}`,
           
          );

          const { excel_details, chat_history } = response.data;

          const {
            summary,
            example_questions,
            excel_url,
            run_id,
            bot_message_id,
            first_char,
            last_char,
            summary_generated_at,
          } = excel_details;

          const initials = `${first_char || ""}${
            last_char || ""
          }`.toUpperCase();
          dispatch(
            updateSummaryMetadata({
              userInitials: initials || "🧑🏻‍💻",
              formattedTimestamp: summary_generated_at || "N/A",
            })
          );

          if (summary) {
            setChatHistory((prev) => {
              const updatedHistory = prev
                .filter(
                  (msg) =>
                    msg.sender !== "bot" ||
                    (msg.text !== "Summarizing..." &&
                      msg.text !==
                        "Failed to fetch summary. Please try again later.")
                )
                .map((msg) =>
                  msg.sender === "bot" && msg.text === "Summarizing..."
                    ? { ...msg, text: summary }
                    : msg
                );

              // Ensure no duplicate summaries
              if (
                updatedHistory.some(
                  (msg) => msg.sender === "bot" && msg.text === summary
                )
              ) {
                return updatedHistory;
              }

              const safeTimestamp = summary_generated_at
                ? new Date(
                    summary_generated_at.split(".")[0] + "Z"
                  ).toISOString()
                : new Date().toISOString();

              return [
                {
                  id: Date.now(),
                  sender: "bot",
                  text: summary,
                  timestamp: safeTimestamp,
                },
                ...updatedHistory,
              ];
            });
          }

          if (chat_history) {
            setChatHistory((prev) => {
              const existingMessageIds = new Set(prev.map((msg) => msg.id));

              const newMessages = chat_history
                .filter((item) => !existingMessageIds.has(item.message_id))
                .map((item) => ({
                  id: item.message_id,
                  sender: item.is_client ? "user" : "bot",
                  text: item.message,
                  timestamp: item.timestamp,
                  runId: item.run_id || null,
                  messageId: item.message_id,
                }));

              return [...prev, ...newMessages];
            });
          }

          setIsSummaryCompleted(true);

          if (example_questions) {
            const questions = example_questions.split(";").map((q) => q.trim());
            streamDummyMessages(questions);
          }
        } catch (error) {
          setChatHistory((prev) => {
            const hasValidData = prev.some(
              (msg) =>
                msg.sender === "bot" &&
                msg.text !== "Failed to fetch summary. Please try again later."
            );

            if (!hasValidData) {
              return [
                ...prev,
                {
                  id: Date.now(),
                  sender: "bot",
                  text: "Failed to fetch summary. Please try again later.",
                },
              ];
            }

            return prev;
          });
        } finally {
          setIsSummaryLoading(false);
          setIsAwaitingResponse(false);
        }
      }
    };

    fetchSummary();
  }, [excelKey]);

  const handleDummyMessageClick = (dummyMessage, index) => {
    if (dummyMessage.trim()) {
      setClickedIndex(index);
      setClientMessage(dummyMessage.trim());
    }
  };

  const isSubmitDisabled = () => {
    return (
      !feedbackMessage.trim() &&
      !Object.values(selectedCheckboxes).some((checked) => checked)
    );
  };

  const streamDummyMessages = (questions) => {
    const maxToShow = 2;
    const limitedQuestions = questions.slice(0, maxToShow);
    setTypedDummyMessages(new Array(maxToShow).fill(""));
    limitedQuestions.forEach((question, index) => {
      let charIndex = 0;
      const interval = setInterval(() => {
        setTypedDummyMessages((prev) => {
          const updatedMessages = [...prev];
          updatedMessages[index] = question.slice(0, charIndex + 1);
          return updatedMessages;
        });
        charIndex += 1;
        if (charIndex === question.length) clearInterval(interval);
      }, 10);
    });
  };

  const streamText = (text, callback, delay = 10) => {
    let charIndex = 0;
    const interval = setInterval(() => {
      const chunk = text.slice(0, charIndex + 1);
      callback(chunk);
      charIndex += 1;
      if (charIndex >= text.length) {
        clearInterval(interval);
      }
    }, delay);
  };

  useEffect(() => {
    if (partialAnswer) {
      setChatHistory((prev) => {
        const lastMessage = prev[prev.length - 1];
        if (lastMessage?.sender === "bot" && !lastMessage.final) {
          lastMessage.text = partialAnswer;
          return [...prev];
        } else if (
          !prev.some(
            (msg) => msg.sender === "bot" && msg.text === partialAnswer
          )
        ) {
          return [
            ...prev,
            { sender: "bot", text: partialAnswer, final: false },
          ];
        }
        return prev;
      });
    }
  }, [partialAnswer]);
  useEffect(() => {
    if (finalAnswer) {
      setChatHistory((prev) => {
        const lastMessage = prev[prev.length - 1];

        if (lastMessage?.sender === "bot" && !lastMessage.final) {
          lastMessage.text = finalAnswer;
          lastMessage.final = true;
          lastMessage.runId = runId || "unknown-run-id";
          lastMessage.messageId = botMessageId || "unknown-message-id";

          return [...prev];
        } else if (
          !prev.some((msg) => msg.sender === "bot" && msg.text === finalAnswer)
        ) {
          const newBotMessage = {
            id: botMessageId || `generated-${Date.now()}`,
            sender: "bot",
            text: finalAnswer,
            final: true,
            runId: runId || "unknown-run-id",
            messageId: botMessageId || "unknown-message-id",
          };

          
          return [...prev, newBotMessage];
        }

        return prev;
      });

      setIsAwaitingResponse(false);
      setIsThinking(false);
      if (generatedQuestions) {
        const questions = generatedQuestions.split(";").map((q) => q.trim());
        streamDummyMessages(questions.slice(0, 2));
      }
      setShowDummyMessages(true);
    }
  }, [finalAnswer, generatedQuestions, runId, botMessageId]);

  const scrollToBottom = () => {
    if (chatContainerRef.current && !isUserScrolling) {
      chatContainerRef.current.scrollTo({
        top: chatContainerRef.current.scrollHeight,
        behavior: "smooth",
      });
    }
  };

  useEffect(() => {
    scrollToBottom();
  }, [chatHistory, typedDummyMessages]);

  const [isScrolling, setIsScrolling] = useState(false);
  const handleScroll = () => {
    if (chatContainerRef.current) {
      const { scrollTop, scrollHeight, clientHeight } =
        chatContainerRef.current;
      const isAtBottom = scrollHeight - clientHeight - scrollTop < 20;

      if (!isAtBottom) {
        setIsUserScrolling(true);
      } else {
        setIsUserScrolling(false);
      }

      if (scrollTop > 50) {
        setShowEarlierMessagesPopup(true);

        if (scrollHeight - clientHeight - scrollTop < 20) {
          setIsScrolling(true);
        } else {
          setIsScrolling(false);
        }
      } else {
        setShowEarlierMessagesPopup(false);
        setIsScrolling(false);
      }
    }
  };

  let scrollTimeout;
  const handleScrollWithTimeout = () => {
    handleScroll();
    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(() => setIsUserScrolling(false), 1000);
  };

  useEffect(() => {
    const container = chatContainerRef.current;
    if (container) {
      container.addEventListener("scroll", handleScrollWithTimeout);
    }
    return () => {
      if (container) {
        container.removeEventListener("scroll", handleScrollWithTimeout);
      }
      clearTimeout(scrollTimeout);
    };
  }, []);

  const submitFeedback = async (
    messageId,
    runId,
    feedbackType,
    userFeedback = ""
  ) => {
    

    if (!messageId || !runId || !feedbackType) {
      console.error("Missing required data for feedback submission.");
      return;
    }

    const payload = {
      message_id: messageId,
      run_id: runId,
      feedback_type: feedbackType,
      user_feedback: userFeedback.trim(),
    };

    

    try {
      let token = await getFreshAccessToken();
      const response = await api.post(
        `api/v1/contract/feedback/`,
        payload,
       
      );

      

      if (response.data.msg === "Feedback recorded successfully.") {
        setShowFeedbackModal(false);
      } else {
      }
    } catch (error) {}
  };

  const handleThumbsUpClick = (messageId) => {
    const clickedMessage = chatHistory.find((msg) => msg.id === messageId);

    if (!clickedMessage) {
      console.error("❌ Clicked message not found in chat history.");
      return;
    }

    const correctBotMessageId = clickedMessage.messageId || clickedMessage.id;
    const correctRunId = clickedMessage.runId || "unknown-run-id";

    if (!correctBotMessageId || !correctRunId) {
      console.error(
        "⚠️ Run ID or Message ID is missing for this message:",
        clickedMessage
      );
      return;
    }

    setThumbsUpClicked((prev) => ({
      ...prev,
      [correctBotMessageId]: true,
    }));

    setThumbsDownClicked((prev) => ({
      ...prev,
      [correctBotMessageId]: false,
    }));

    setPopupVisible(true);

    submitFeedback(correctBotMessageId, correctRunId, "up");
  };

  const handleThumbsDownClick = (messageId) => {
    const clickedMessage = chatHistory.find((msg) => msg.id === messageId);

    if (!clickedMessage) {
      return;
    }

    const correctBotMessageId = clickedMessage.messageId || clickedMessage.id;
    const correctRunId = clickedMessage.runId;

    if (!correctBotMessageId || !correctRunId) {
      console.error(
        "⚠️ Run ID or Message ID is missing for this message:",
        clickedMessage
      );
      return;
    }

    setThumbsDownClicked((prev) => ({
      ...prev,
      [messageId]: true,
    }));

    setThumbsUpClicked((prev) => ({
      ...prev,
      [messageId]: false,
    }));

    setShowThumbsDownPopup(true);

    setMessageIdToFeedback(correctBotMessageId);
    setRunIdToFeedback(correctRunId);
  };

  useEffect(() => {
    if (status === "succeeded") {
      const newBotMessage = {
        id: Date.now(),
        sender: "bot",
        text: finalAnswer,
      };
      setChatHistory((prev) => [...prev, newBotMessage]);
    }
  }, [status, finalAnswer]);

  const handleCopy = (messageId, text) => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        setCopiedMessageId(messageId);
        setTimeout(() => setCopiedMessageId(null), 2000);
      })
      .catch((err) => {
        console.error("Failed to copy message:", err);
      });
  };

  const [selectedCheckboxes, setSelectedCheckboxes] = useState({
    factuallyIncorrect: false,
    refused: false,
    notFollowingInstructions: false,
  });

  const handleCheckboxChange = (e) => {
    const { id, checked } = e.target;
    setSelectedCheckboxes((prev) => {
      const updatedState = {
        ...prev,
        [id]: checked,
      };
      return updatedState;
    });
  };
  const handleTextareaChange = (e) => {
    setFeedbackMessage(e.target.value);
  };
  const handleGoToInvoices = () => {
    navigate("/Invoices");
  };

  const handleSubmitThumbsDownFeedback = async () => {
    const selectedFeedback = [];
    if (selectedCheckboxes.factuallyIncorrect) {
      selectedFeedback.push("Not factually correct.");
    }
    if (selectedCheckboxes.refused) {
      selectedFeedback.push("Refused when it shouldn’t have.");
    }
    if (selectedCheckboxes.notFollowingInstructions) {
      selectedFeedback.push("Not following instructions.");
    }

    const combinedFeedback = [...selectedFeedback, feedbackMessage]
      .join("\n")
      .trim();
    

    if (!messageIdToFeedback || !runIdToFeedback) {
      console.error("Missing messageId or runId for thumbs down feedback.");
      return;
    }

    try {
      await submitFeedback(
        messageIdToFeedback,
        runIdToFeedback,
        "down",
        combinedFeedback
      );

      setSelectedCheckboxes({
        factuallyIncorrect: false,
        refused: false,
        notFollowingInstructions: false,
      });
      setFeedbackMessage("");
      setShowThumbsDownPopup(false);
    } catch (error) {
      console.error("Error submitting thumbs-down feedback:", error);
    }
  };

  const handleClosePopup = () => {
    setPopupVisible(false);
    setShowThumbsDownPopup(false);
    setSelectedCheckboxes({
      factuallyIncorrect: false,
      refused: false,
      notFollowingInstructions: false,
    });
    setFeedbackMessage("");
  };

  useEffect(() => {
    if (generatedQuestions) {
      const questions = generatedQuestions.split(";").map((q) => q.trim());
      streamDummyMessages(questions);
    }
  }, [generatedQuestions]);

  useEffect(() => {
    if (
      chatHistory.length > 0 &&
      chatHistory[chatHistory.length - 1]?.sender === "bot"
    ) {
      const newMessageId = chatHistory[chatHistory.length - 1]?.id;
      setThumbsUpClicked((prev) => ({
        ...prev,
        [newMessageId]: false,
      }));
      setThumbsDownClicked((prev) => ({
        ...prev,
        [newMessageId]: false,
      }));
    }
  }, [chatHistory]);

  const groupMessagesByDate = (messages) => {
    const sortedMessages = [...messages].sort(
      (a, b) => new Date(a.timestamp) - new Date(b.timestamp)
    );

    const groupedMessages = {};

    sortedMessages.forEach((message) => {
      let label;

      try {
        const messageDate = message.timestamp
          ? new Date(message.timestamp)
          : null;

        if (!messageDate || isNaN(messageDate.getTime())) {
          // label = formattedTimestamp || "Summary";
          label = "Summary";
        } else {
          const today = new Date();
          const yesterday = new Date(today);
          yesterday.setDate(today.getDate() - 1);

          if (messageDate.toDateString() === today.toDateString()) {
            label = "Today";
          } else if (messageDate.toDateString() === yesterday.toDateString()) {
            label = "Yesterday";
          } else {
            label = format(messageDate, "dd MMM yyyy");
          }
        }
      } catch (error) {
        console.error("Error processing message timestamp:", message, error);
        label = "Invalid Date";
      }

      if (!groupedMessages[label]) {
        groupedMessages[label] = [];
      }
      groupedMessages[label].push(message);
    });

    return groupedMessages;
  };

  const groupedChatHistory = groupMessagesByDate(chatHistory);

  useEffect(() => {
    const container = chatContainerRef.current;
    if (container) {
      container.addEventListener("scroll", handleScroll);
    }
    return () => {
      if (container) {
        container.removeEventListener("scroll", handleScroll);
      }
    };
  }, []);

  useEffect(() => {
    if (clientMessage.trim() !== "") {
      setShowEarlierMessagesPopup(false);
    }
  }, [clientMessage]);

  return (
    <div className="full-container">
      <div className="pl-[-10] -ml-16">
        <Header
          icon="/arrow-back.svg"
          name="Go to Spreadsheets"
          onGoToInvoices={() => navigate("/Spreadsheet")}
        />
      </div>
      <div className="content-container">
        <div className="left-side">
          {showEarlierMessagesPopup && (
            <div
              className="fixed transform -translate-x-1/2 inline-flex items-center justify-center gap-1.5 px-4 py-1 text-sm font-outfit font-normal text-primary-500 border border-black/10 rounded-full bg-gradient-to-r from-[#F5F4F3] to-[#FCDFF9] shadow-custom "
              style={{
                top: `${55}px`,
                left: `${438}px`,
                color: "#C95EBE",
                fontFamily: "Outfit",
                fontSize: "14px",
                fontWeight: "400",
                lineHeight: "normal",
                opacity: isScrolling ? "0.5" : "3",
              }}
            >
              <span>See earlier messages</span>
            </div>
          )}
          <div className="message-container " ref={chatContainerRef}>
            {Object.entries(groupedChatHistory)
              .sort(([dateA], [dateB]) => {
                if (dateA === "Today") return 1;
                if (dateB === "Today") return -1;
                return new Date(dateA) - new Date(dateB);
              })
              .map(([dateLabel, messages]) => (
                <div key={dateLabel}>
                  {/* Date Label */}
                  <div className="flex items-center justify-center my-4">
                    <div className="h-px w-[269px] bg-black/10"></div>
                    <div className="flex items-center justify-center gap-1 px-4 py-1.5 mx-3 rounded-full border border-black/10 shadow-md text-neutral-600 text-sm font-normal">
                      {dateLabel}
                    </div>
                    <div className="h-px w-[269px] bg-black/10"></div>
                  </div>

                  {/* Messages for the Date */}
                  {messages.map((message, index) => {
                    // Check if this is the last bot message of the latest conversation
                    const isLatestBotMessage =
                      message.sender === "bot" &&
                      index === messages.length - 1 && // Ensures it's the last message in the group
                      dateLabel === "Today" && // Ensures it's today's latest response
                      !isAwaitingResponse; // Hides chart when waiting for a response

                    return (
                      <div
                        key={message.id || index}
                        className={`mb-0 ${
                          message.sender === "user"
                            ? "w-full flex justify-end"
                            : "bot-message-container w-full flex items-start"
                        }`}
                      >
                      

                        {message.sender === "bot" ? (
                    <div className="flex items-start gap-2 mb-4">
  <div className="w-[24px] h-[24px] mt-5 flex-shrink-0">
    <img src="/dclogo.svg" alt="Bot Icon" className="bot-icon w-full h-full rounded-full" />
  </div>

  <div className="flex flex-col max-w-[642px]">
                            {(isThinking && index === chatHistory.length - 1) ||
                            message.text === "" ? (
                              <div className="thinking-indicator mb-7">
                                <span className="dot"></span>
                                <span className="dot"></span>
                                <span className="dot"></span>
                              </div>
                            ) : (
                              <span
                                className="bot-message-content"
                                dangerouslySetInnerHTML={{
                                  __html: formatText(message.text),
                                }}
                              />
                            )}

                            {/* {isLatestBotMessage && barChart && typeof barChart === "string" && barChart.trim() !== "" && (
  <div className="chart-container">
    <h3>Bar Chart</h3>
    <img src={`data:image/png;base64,${barChart}`} alt="Bar Chart" />
  </div>
)} */}

                            {message.sender === "bot" &&
                              message.text &&
                              !isThinking &&
                              (isSummaryCompleted || finalAnswer) && (
                                <div className="reactions flex gap-2 text-gray-500 mt-2">
                                  <span
                                    className="reaction-icon cursor-pointer"
                                    onClick={() => {
                                      handleThumbsUpClick(
                                        message.id,
                                        message.runId
                                      );
                                    }}
                                  >
                                    <img
                                      src={
                                        thumbsUpClicked[message.id]
                                          ? "/thums-up-filleds.svg"
                                          : "/thums-ups.svg"
                                      }
                                      alt="Thumbs Up"
                                    />
                                    <span className="reaction-tooltip">
                                      Thumbs Up
                                    </span>
                                  </span>
                                  <span
                                    className="reaction-icon cursor-pointer"
                                    onClick={() => {
                                      handleThumbsDownClick(
                                        message.id,
                                        message.runId
                                      );
                                    }}
                                  >
                                    <img
                                      src={
                                        thumbsDownClicked[message.id]
                                          ? "/thums-down-filleds.svg"
                                          : "/thums-downs.svg"
                                      }
                                      alt="Thumbs Down"
                                    />
                                    <span className="reaction-tooltip">
                                      Thumbs Down
                                    </span>
                                  </span>
                                  <span
                                    className="reaction-icon cursor-pointer"
                                    onClick={() =>
                                      handleCopy(message.id, message.text)
                                    }
                                  >
                                    <img
                                      src={
                                        copiedMessageId === message.id
                                          ? "/copy-clicked.svg"
                                          : "/copys.svg"
                                      }
                                      alt="Copy"
                                    />
                                    <span className="reaction-tooltip">
                                      Copy
                                    </span>
                                  </span>
                                </div>
                              )}
                               </div>
                          </div>
                        ) : (
                          <div className="w-full flex justify-end items-start gap-4">
                            <div className="user-message-bubble">
                              {message.text}
                            </div>
                            <div className="user-icon-container flex-shrink-0 self-end">
                              {/* <div className="user-icon w-7 h-7 flex items-center justify-center rounded-full bg-white text-[#C95EBE] border border-[rgba(0,0,0,0.10)] text-[13px] font-outfit font-medium leading-none mr-3">
                                {userInitials}
                              </div> */}
                            </div>
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              ))}

            {error && (
              <div className="bot-message-container w-full flex items-start mb-4">
                <div className="bot-message-content text-red-600 text-sm rounded-lg p-4 max-w-[85%]">
                  <strong>Error:</strong> {error}
                </div>
              </div>
            )}

            <div className="dummy-container flex flex-col gap-2 mr-20 mb-4">
              {showDummyMessages &&
                typedDummyMessages.map((question, index) => (
                  <div
                    key={index}
                      className={`dummy-message-box border border-grey-400 rounded-lg p-4 flex items-center cursor-pointer ${
                      clickedIndex === index ? "opacity-50" : "opacity-100"
                    }`}
                    onClick={() =>
                      handleDummyMessageClick(question.trim(), index)
                    }
                  >
                    {/* <span className="icon mr-2">
                      <img src="/star-dot.svg" alt="Star Icon" />
                    </span> */}
                    <p className="text-sm">{question.trim()}</p>
                  </div>
                ))}
            </div>
          </div>
<div className={`w-full max-w-3xl px-4 py-2 bg-white ${getLineStyle()} flex items-center`}>
      <textarea

        ref={textareaRef}
        rows={1}
        value={clientMessage}
      onChange={(e) => {
  setClientMessage(e.target.value);
  if (textareaRef.current) {
    textareaRef.current.style.height = "auto";
    textareaRef.current.style.height = `${Math.min(
      textareaRef.current.scrollHeight,
      88
    )}px`;
  }
}}
onKeyDown={(e) => {
        if (e.key === "Enter" && !e.shiftKey) {
          e.preventDefault();
          if (!isAwaitingResponse && !isSummaryLoading && clientMessage.trim() &&  (isSummaryCompleted)
          ) {
            handleSend(clientMessage.trim());
            setClientMessage("");
          }
        }
      }}

         placeholder={
        !isSummaryCompleted
          ? "Summarizing..."
          : isAwaitingResponse
          ? "Copilot is responding..."
          : "Ask  me anything..."
      }
className="w-full bg-transparent resize-none overflow-y-auto leading-[20px] outline-none max-h-[88px] min-h-[22px] pr-4
text-[15px] font-medium text-[--Neutral_2] font-outfit placeholder:text-[15px] placeholder:font-medium placeholder:text-[--Neutral_2]"
        style={{
  color: "var(--Neutral_2, #52525B)",
  fontFamily: "Outfit",
  fontSize: "15px",
  fontStyle: "normal",
  fontWeight: 500,
  lineHeight: "normal"
}}

      />
     <button
  className="flex-shrink-0 p-2 send-button-holders"
 
 
  onClick={() => {
              try {
            
               
            
                if (
                  isSummaryLoading ||
                  isAwaitingResponse ||
                  (isSummaryWebSocketActiveNow && !isSummaryCompleted)
                ) {
                  dispatch(stopStreaming());
                  setIsAwaitingResponse(false);
                  setIsThinking(false);
                  setShouldForceStopThinking(true);
                } else {
                  dispatch(resetStopStreaming());
                  
                  handleSend();
                }
              } catch (err) {
                console.error("💥 Error in onClick:", err);
              }
            }}
>
  <img
    src={
      isSummaryLoading ||
      isAwaitingResponse ||
      (!isSummaryCompleted)
        ? "/loading-send-button.svg"
        : "/send.svg"
    }
    alt="Send"
    className="w-[20px] h-[20px]"
     // ✅ Prevent opacity from changing when disabled
  />
</button>

    </div>
       

      
        </div>
        <div className="right-side-cono">
        <PdfViewer
  pdfUrl={excelUrl}
 
/>



        </div>
      </div>
      {showThumbsDownPopup && (
        <div className="popup-container-thumsdown">
          <div className="popup-content-thumsdown">
            <div>
              <div>
                <button
                  className="close-button-thumsdown"
                  onClick={() => setShowThumbsDownPopup(false)}
                >
                  <p>x</p>
                </button>
              </div>
              <div className="paragraph-container">
                <p className="paragraph-container-para1">What went Wrong?</p>
                <p className="paragraph-container-para2">
                  Select feedback that reflects how well this response addressed
                  your question or concern.
                </p>
                <div className="checkbox-container-thumsup">
                  <label className="thumsup-checkbox">
                    <input
                      type="checkbox"
                      className="thumbsup1"
                      id="factuallyIncorrect"
                      checked={selectedCheckboxes.factuallyIncorrect}
                      onChange={handleCheckboxChange}
                    />
                    Not factually correct.
                  </label>
                  <label className="thumsup-checkbox">
                    <input
                      type="checkbox"
                      className="thumbsup2"
                      id="refused"
                      checked={selectedCheckboxes.refused}
                      onChange={handleCheckboxChange}
                    />
                    Refused when it shouldn’t have.
                  </label>
                  <label className="thumsup-checkbox">
                    <input
                      type="checkbox"
                      className="thumbsup3"
                      id="notFollowingInstructions"
                      checked={selectedCheckboxes.notFollowingInstructions}
                      onChange={handleCheckboxChange}
                    />
                    Not Following Instructions.
                  </label>
                </div>
                <div className="line-with-text">
                  <span>Or</span>
                </div>
                <div className="rectangular-box">
                  <div className="feedback-container">
                    <textarea
                      className="feedback-input resize-none border-none focus:outline-none focus:ring-0"
                      maxLength="250"
                      placeholder="Your feedback is much appreciated and helps improve the AI!"
                      value={feedbackMessage}
                      onChange={(e) => setFeedbackMessage(e.target.value)}
                    />
                  </div>
                  <p className="character-count">Maximum: 250 characters</p>
                </div>
                <button
                  className={`custom-button-thumsdown ${
                    isSubmitDisabled()
                      ? "disabled-button-thumsdown"
                      : "enabled-button-thumsdown"
                  }`}
                  onClick={handleSubmitThumbsDownFeedback}
                  disabled={isSubmitDisabled()}
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default ExcelChat;